var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomanArmFore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "119px",
    height: "91px",
    viewBox: "0 0 119 91",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WomanArmFore") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "WomanArmFore",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.0632775,84.5634503 L58.6025125,90.7317254 C64.1808621,91.9367094 67.2788384,88.9673561 65.4957588,84.1333852 L49.3384677,40.4181285 C47.5454267,35.5831551 41.5188169,30.6409161 35.9404673,29.4359321 L7.40123221,23.2686594 C1.82288261,22.0626729 -1.28505503,25.0320262 0.507985914,29.8669996 L16.6652771,73.5812539 C18.458318,78.4162272 24.4849279,83.3584662 30.0632775,84.5634503",
    id: "Fill-161",
    fill: "#1C7EC9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.0187047,68.2314848 L45.0187047,68.232476 C45.2623152,70.9198313 47.6476674,73.063966 50.3070815,72.9985417 L59.5744288,72.7675738 C62.2439932,72.7021495 64.2233281,70.4519479 63.9797176,67.7675666 C63.7361072,65.0812026 61.3507549,62.9350853 58.6913409,63.0015009 L49.4239936,63.2314775 C46.7645796,63.2988844 44.7852447,65.5480947 45.0187047,68.2314848",
    id: "Fill-162",
    fill: "#ED5353"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.547813,0 C102.547813,0 125.447398,50.2886938 117.213504,68.1160974 C108.97961,85.9435011 61,74.2117268 61,74.2117268 L73.3558198,62.0642285 L97.5596859,56.9522143 L90.7196793,13.5120282 L102.547813,0",
    id: "Fill-163",
    fill: "#FF9B3D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWomanArmFore);
export default __webpack_public_path__ + "static/media/WomanArmFore.8e503a386d1eca2627972186dc395539.svg";
export { ForwardRef as ReactComponent };